<template>
    <div id="email-match-multiple" class="width-stretch">
        <div
          class="flex-row align-items-center p-0 pr-md mb-sm"
        >
          <dd-rounded-button
              icon="mdi mdi-arrow-left"
              @click="goBack"
              style="cursor: pointer; margin-top: -5px"
          />
          <h1
            @click="goBack"
            style="cursor: pointer"
          >
            E-mail koppelen
          </h1>
        </div>
				<div class="flex-row gap-md" >
						<div style="width: 55%">
								<dd-card>
									<match-component></match-component>
								</dd-card>
						</div>
						<div style="flex: 1" class="flex-col gap-md">
								<dd-header-card
                    v-for="email in emailData"
                    :key="email.id"
                    class="flex-stretch"
                    :header="email.subject"
                >
                  <div class="couple-row pb-sm">
                    <div class="width-stretch flex-row">
                      <p class="m-0">Email opslaan als</p>
                    </div>
                    <dd-input v-model="email.name"></dd-input>
                  </div>
                  <div v-if="email.data.attachments.length > 0" class="couple-row pb-sm">
                    <dd-switch v-model="email.attachAttachments" style="place-self: flex-start"></dd-switch>
                    <div>
                      <p class="m-0">Bijlagen apart opslaan</p>
                      <div v-if="email.attachAttachments">
                        <div
                            class="flex-row align-items-center mt-xs gap-sm"
                            v-for="(attachment,index) in email.data.attachments"
                            :key="index"
                        >
                          <dd-switch v-model="attachment.should_import" :checked="true"></dd-switch>
                          <dd-input class="width-stretch" v-model="attachment.filename"></dd-input>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="flex-col width-stretch pb-md">
                    <iframe
                        sandbox
                        class="width-stretch pb-md"
                        :srcdoc="email.content"
                        style="height: 600px; border: none"
                        @load="hideHorizontalOverflow"
                    ></iframe>
                  </div>
								</dd-header-card>
						</div>
				</div>
    </div>
</template>

<script>
import emailApi from '~/api/email';
import MatchComponent from "./MatchComponent.vue";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "MatchMultipleComponent.vue",
  components: { MatchComponent },
  data(){
    return {
      emailData: [],
    }
  },
  mounted(){
    Promise.all(this.selectedEmails.map( async (email) => {
      const content = (await emailApi.getBody(email.id)).body;
      this.emailData.push({...email, content});
    }));
  },
  methods:{
    ...mapActions('email', [
      "goBack"
    ]),
    hideHorizontalOverflow(e){
        const html = e.target.contentWindow.document.children[0];
        html.style.overflowX = 'hidden';

    }
  },
  computed:{
    ...mapGetters('email',[
        "emails",
        "selectedEmails"
    ])
  }
}

</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
.couple-row{
  display: flex;
  flex-direction: row;
  align-items: center;
}
.couple-row>*:nth-child(1){
  flex: 0.2;
  display: flex;
  align-items: flex-end;
  margin-right: $spacing-md;
}
.couple-row>*:nth-child(2){
  flex: 0.8;
}
</style>
